/**
 * @file
 * Simple helpers for the ymca_swo_lb theme.
 */

(function ($, Drupal, drupalSettings, once) {

  "use strict";

  Drupal.behaviors.eventListingViewsSwitch = {
    attach: function (context, settings) {
      once('views-switch', $('.switcher-inner .switch-button', context)).forEach(function (el) {

        $(el).on('click', function () {

          $('.switcher-inner .switch-button', context).removeClass('active');
          $(this).addClass('active');

          const display = $(this).attr('data-display');

          $('.view-display').hide();
          $('.view-display[data-display="' + display + '"]').show();

        });

      });
    }
  };

  Drupal.behaviors.universalViewsFilter = {
    attach: function (context) {
      const $submitButton = $(once('sync-submit-persistent', '.views-exposed-form [id^="edit-submit-"]', context));

      $submitButton.on('click', function (e) {
        const $form = $(this).closest('form');
        const formData = $form.serializeArray();
        const queryString = $.param(formData);

        const newUrl = window.location.pathname + '?' + queryString;
        window.history.pushState({ path: newUrl }, '', newUrl);

        // Loop through all exposed forms on the page
        $('.views-exposed-form', context).each(function () {
          var $exposed_form = $(this);

          if (!$exposed_form.is($form)) {
            formData.forEach(item => {
              $exposed_form.find('[name="' + item.name + '"]').val(item.value);
            });

            // Trigger the form submit — Views AJAX will handle the refresh
            $exposed_form.find('[id^="edit-submit-"]').trigger('click');
          }
        });
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
